import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd, MdRemove } from "react-icons/md";
import { Input, FormGroup, Label, Button, Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import CKEditor from "react-ckeditor-component";
import { getTicketType, getTicketSubType, getAllTicketType } from "../../redux/actions/indexActions";
import { Link } from "react-router-dom";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";

const AddNotice = ({ placeId }) => {
    const [notice, setNotice] = useState("");
    const [errors, setErrors] = useState({});
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { editBookingForm} } = useSelector((state) => state);

    useEffect(() => {
        if (editBookingForm) {
            setNotice(editBookingForm?.notice || "");
        }
    }, [editBookingForm]);

    const handleSubmitNotice = () => {
        if (!placeId) {
            toast.error("Place ID is required.");
            return;
        }
        const form = new FormData();
        form.append("notice", notice);
        form.append("place_id", placeId);
        axios.post(`/api/admin/v1/add-update-ticket-notice`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`, 
            },
        })
            .then((res) => {
                setNotice(res.data?.data?.notice || "");
                toast.success(res.data?.message);
            })
            .catch((err) => {
                if (err.response) {
                    const errorMessage = err.response.data?.message || "An error occurred";
                    toast.error(errorMessage);
                    setErrors(err.response.data);
                } else if (err.request) {
                    toast.error("No response from server. Please check your connection.");
                } else {
                    toast.error("An unexpected error occurred.");
                }
            });
    };

    console.log('editBookingForm>>',editBookingForm);

    return (
        <div className="container bg-white px-4 py-4">
            <Row>
                <Col md={12}>
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-primary text-white">
                            {/* <h6 className="mb-0">Add Notice</h6> */}
                        </CardHeader>
                        <CardBody>
                            <FormGroup>
                                <CKEditor
                                    activeClass="p10"
                                    content={notice || ""}
                                    events={{
                                        change: (e) =>setNotice((prev) => (e.editor.getData()))
                                    }}
                                />
                            </FormGroup>
                            {errors?.notice && <span className="text-danger">{errors.notice}</span>}
                            {editBookingForm?.notice ? (
                                <Button color="primary" onClick={handleSubmitNotice}>Update Notice</Button>
                            ):(
                                <Button color="primary" onClick={handleSubmitNotice}>Add Notice</Button>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AddNotice;
